import { Dictionary } from '../Components/Common/CommonModel';
import { Permissions } from '../Components/Layout/UIContainer/Global/GlobalState';
import RestartTenant from '../Components/Layout/PlatformEngineering/Components/RestartTenant';
import KeyValutTable from '../Components/Layout/KeyVault/Home';
import { NoAccess } from '../Components/Layout/Common/NoAccess';
import AuditHome from '../Components/Layout/Audit/AuditHomePage';
import ModulesHomePage from '../Components/Layout/Module/ModulesHomePage';
import StorageAccountOps from '../Components/Layout/StorageAccount/Components/StorageAccountOps';
import AzureSearchServiceOps from '../Components/Layout/SearchService/Components/AzureSearchServiceOps';
import SecureKeyOps from '../Components/Layout/KeyVault/Components/SecureKeyOps';
import AccessControlHome from '../Components/Layout/AccessControl/AccessControlHome';
import StorageAccountHome from '../Components/Layout/StorageAccount/StorageAccountsHome';
import AzureSearchServiceHome from '../Components/Layout/SearchService/AzureSearchServiceHome';
import CreateTemplate from '../Components/Layout/EmailAdministration/Components/CreateTemplate';
import EditTemplate from '../Components/Layout/EmailAdministration/Components/EditTemplate';
import SendEmailPage from '../Components/Layout/EmailAdministration/Components/SendEmailPage';
import EmailAdmin from '../Components/Layout/EmailAdministration/EmailAdminHomePage';
import { accessCheckFunctions } from './permissionAccessHelper';
import SqlServerHome from '../Components/Layout/SqlServer/SqlServerHome';
import SqlServerCreate from '../Components/Layout/SqlServer/Components/SqlServerCreate';
import SqlServerDelete from '../Components/Layout/SqlServer/Components/SqlServerDelete';
import SqlServerEdit from '../Components/Layout/SqlServer/Components/SqlServerEdit';
import SqlEditorPage from '../Components/Layout/SqlEngine/pages/SqlEditorPage';

export const pageFunctions: Record<
  string,
  (
    permissions: Dictionary<Permissions>,
    isProduction: boolean,
  ) => React.ComponentType<React.JSX.Element>
> = {
  TenantRestartPage: (permissions, isProd) =>
    accessCheckFunctions.hasTenantRestartAccess(permissions, isProd)
      ? RestartTenant
      : NoAccess,

  KeyVaultPage: (permissions, isProd) =>
    accessCheckFunctions.hasKeyVaultAccess(permissions, isProd)
      ? KeyValutTable
      : NoAccess,

  EmailTemplatePage: (permissions, isProd) =>
    accessCheckFunctions.hasEmailAccess(permissions, isProd)
      ? EmailAdmin
      : NoAccess,

  EmailSendPage: (permissions, isProd) =>
    accessCheckFunctions.hasEmailSendAccess(permissions, isProd)
      ? SendEmailPage
      : NoAccess,

  EditTemplatePage: (permissions, isProd) =>
    accessCheckFunctions.hasEmailAccess(permissions, isProd)
      ? EditTemplate
      : NoAccess,

  CreateTemplatePage: (permissions, isProd) =>
    accessCheckFunctions.hasEmailAccess(permissions, isProd)
      ? CreateTemplate
      : NoAccess,

  StorageAccountPage: (permissions, isProd) =>
    accessCheckFunctions.hasStorageAccountAccess(permissions, isProd)
      ? StorageAccountHome
      : NoAccess,
  AzureSearchServicePage: (permissions, isProd) =>
    accessCheckFunctions.hasAzureSearchServiceAccess(permissions, isProd)
      ? AzureSearchServiceHome
      : NoAccess,

  SqlServerPage: (permissions, isProd) =>
    accessCheckFunctions.hasSqlServerAccess(permissions, isProd)
      ? SqlServerHome
      : NoAccess,

  SqlServerCreate: (permissions, isProd) =>
    accessCheckFunctions.hasSqlServerAccess(permissions, isProd)
      ? SqlServerCreate
      : NoAccess,

  SqlServerEdit: (permissions, isProd) =>
    accessCheckFunctions.hasSqlServerAccess(permissions, isProd)
      ? SqlServerEdit
      : NoAccess,

  SqlServerDelete: (permissions, isProd) =>
    accessCheckFunctions.hasSqlServerAccess(permissions, isProd)
      ? SqlServerDelete
      : NoAccess,

  AccessControlPage: (permissions, isProd) =>
    accessCheckFunctions.hasAccessControlAccess(permissions, isProd)
      ? AccessControlHome
      : NoAccess,

  SecureKeyOpsPage: (permissions, isProd) =>
    accessCheckFunctions.hasKeyVaultWriteAccess(permissions, isProd)
      ? SecureKeyOps
      : NoAccess,

  StorageAccountOpsPage: (permissions, isProd) =>
    accessCheckFunctions.hasStorageAccountWriteAccess(permissions, isProd)
      ? StorageAccountOps
      : NoAccess,

  AzureSearchServiceOpsPage: (permissions, isProd) =>
    accessCheckFunctions.hasAzureSearchServiceWriteAccess(permissions, isProd)
      ? AzureSearchServiceOps
      : NoAccess,

  ModulePage: (permissions, isProd) =>
    accessCheckFunctions.hasModuleWriteAccess(permissions, isProd)
      ? ModulesHomePage
      : NoAccess,

  AuditPage: (permissions, isProd) =>
    accessCheckFunctions.hasAuditAccess(permissions, isProd)
      ? AuditHome
      : NoAccess,

  SqlEnginePage: (permissions, isProd) =>
    accessCheckFunctions.hasSqlEngineAccess(permissions, isProd)
      ? SqlEditorPage
      : NoAccess,
};
